import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'kwh'
})
export class KwhPipe implements PipeTransform {

  constructor(private decimalPipe: DecimalPipe = new DecimalPipe('de-DE')) {

  }

  transform(value: any, digits?: any): any {
    return this.decimalPipe.transform(value / 1000, digits ? `1.${digits}-${digits}` : '1.3-3', 'de-DE')
  }

}
